import axios from 'axios';
import { camelizeKeys } from 'humps';
import { getEndpoint } from './api';

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.message === 'Network Error') {
      return { response: { status: 401 } };
    }
    return Promise.reject(error);
  },
);

export const makeRequest = async ({
  method = 'POST',
  apiUrl,
  userId,
  currentSession,
  route,
  data,
  params = {},
  headers = {},
}) => {
  const url = getEndpoint(apiUrl)[route];
  const jwt = currentSession;

  return axios({
    method,
    url,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${jwt}`,
      'x-cognito-id': userId,
      ...headers,
    },
    data,
    params,
  })
    .then((success) => {
      if (success?.response?.status === 401) {
        throw success.response;
      }

      return camelizeKeys(success.data);
    })
    .catch((error) => {
      if (error.status === 401) {
        throw error;
      }
      // if any 500 error codes, trigger game crash modal
      if (Math.floor(error?.response?.status / 100) === 5) {
        const err = { code: 500 };
        throw err;
      }
      const data = error.response.data;
      if (data?.code === 'noContest') return data;
      throw data;
    });
};
